
export default function (fnc) {
  return {
    onMouseDown:(e)=>{
      e.currentTarget.down_at={
        x:e.pageX,
        y:e.pageY,
      }
    },
    onMouseUp:(e)=>{
      e.currentTarget.up_at={
        x:e.pageX,
        y:e.pageY,
      };
      console.log("e.target.down_at",e.currentTarget,e.currentTarget.down_at);
      if(Math.abs(e.currentTarget.down_at.x-e.currentTarget.up_at.x)<5 && Math.abs(e.currentTarget.down_at.y-e.currentTarget.up_at.y)<5) {
        fnc(e);
      }
    }
  }
}